export const storyItems = [
  {
    id: 'story-1',
    type: 'story',
    title: '第一幕 · 雨夜重逢',
    subtitle: '第 1 集｜雨夜、旧酒吧与一句迟到了七年的话',
    excerpt:
      '旧城最后一盏还亮着的霓虹灯下，陈默推开了"归途"酒吧的门。他没想到，替他递上毛巾的人，会是七年前不告而别的江暖。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20rain%20soaked%20old%20city%20alley%20at%20night%2C%20two%20distant%20silhouettes%20standing%20apart%20under%20a%20warm%20amber%20street%20lamp%2C%20wet%20cobblestone%20reflections%2C%20dense%20fog%2C%20deep%20charcoal%20shadows%2C%20golden%20rim%20light%2C%20subtle%20film%20grain%2C%20moody%20teal%20free%20warm%20palette%2C%20professional%20cinematography%20composition&width=1200&height=700&seq=story-scene-01&orientation=landscape',
    date: '2025-03-02',
    dateLabel: '第 1 集 · 2025.03.02 播出',
    weight: 96,
    tags: ['雨夜', '重逢', '陈默', '江暖'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 1 集' },
      { label: '场景', value: '旧城 · 归途酒吧' },
      { label: '关键词', value: '重逢 / 错过 / 沉默' },
    ],
    quote: '有些人不是走散了，只是把话留在了那个雨夜里。',
    body: [
      '雨从傍晚开始下，一直没停。旧城的街道被水洗得发亮，霓虹灯的倒影在积水中摇晃。陈默把车停在巷口，撑开一把已经掉了漆的黑伞，走向那家七年前常来的酒吧。招牌换了，字却还是旧字体，"归途"两个字被雨打得有些模糊。',
      '他本来只是路过。剧组收工太晚，回酒店的路被封了，他想找个地方坐一会儿。推门进去的时候，风铃响了一声，柜台后面的人抬头，两个人同时停住了。',
      '江暖把毛巾递过来，动作自然得像是昨天才见过。她说，好久不见。陈默接过毛巾，没有擦头发，只是握在手里，说了一句更轻的话：你回来了。',
      '这一集几乎没有解释。没有交代她当年为什么走，也没有交代他这七年怎么过。镜头只是在两个人之间来回切换，把所有的空白都留在沉默里。直到打烊，江暖关掉最后一盏灯，说：明天我还要来上班，你要不要也来。',
    ],
  },
  {
    id: 'story-2',
    type: 'story',
    title: '第二幕 · 一张旧照片',
    subtitle: '第 2 集｜抽屉、合影与一个被裁掉的人',
    excerpt:
      '陆嘉行整理旧物时翻出一张毕业合影，照片右侧被整齐地剪掉了。剪口很新，新到像是昨天才动的手。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20old%20wooden%20desk%20drawer%20half%20open%20with%20a%20faded%20group%20photograph%20and%20scissors%20resting%20beside%20it%2C%20single%20warm%20desk%20lamp%20light%2C%20deep%20brown%20interior%20shadows%2C%20dust%20particles%20in%20the%20air%2C%20shallow%20depth%20of%20field%2C%20muted%20amber%20and%20charcoal%20tones%2C%20film%20grain%2C%20intimate%20mystery%20atmosphere&width=1200&height=700&seq=story-scene-02&orientation=landscape',
    date: '2025-03-09',
    dateLabel: '第 2 集 · 2025.03.09 播出',
    weight: 88,
    tags: ['旧照片', '秘密', '陆嘉行', '线索'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 2 集' },
      { label: '场景', value: '陆家 · 书房' },
      { label: '关键词', value: '隐瞒 / 兄弟 / 证据' },
    ],
    quote: '照片不会说谎，但剪照片的人会。',
    body: [
      '陆嘉行的书房常年锁着。这天他难得打开，是为了找一份旧合同。合同没找到，抽屉最深处却滑出一张照片——大学毕业那年的合影，十几个人挤在台阶上，笑得很用力。',
      '照片右侧缺了一块。边缘整齐，是被人用剪刀裁掉的。陆嘉行盯着那个缺口看了很久，然后把照片翻过来，背面有一行褪色的字：以后要一起拍一部电影。字迹是陈默的。',
      '这一集开始把三条时间线并在一起。观众第一次看到，三个人的关系并不只是"朋友"和"妻子"这么简单。被剪掉的那个人是谁，剧集没有给答案，只给了一个空位。',
      '结尾，陆嘉行把照片放回抽屉，却没有锁。他站在窗前抽了一支烟，然后把烟按灭在花盆里——那是江暖养了三年的植物。',
    ],
  },
  {
    id: 'story-3',
    type: 'story',
    title: '第三幕 · 朋友的名义',
    subtitle: '第 3 集｜三个人坐在同一张桌子上',
    excerpt:
      '一顿再普通不过的家常饭，三个人都吃得格外小心。筷子碰到碗沿的声音，比任何一句台词都响。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20dinner%20table%20for%20three%20in%20a%20dim%20warm%20apartment%2C%20steaming%20bowls%20and%20chopsticks%2C%20empty%20fourth%20chair%2C%20soft%20amber%20pendant%20lamp%20overhead%2C%20charcoal%20shadows%20in%20the%20background%2C%20tense%20restrained%20mood%2C%20shallow%20focus%2C%20subtle%20film%20grain%2C%20elegant%20muted%20warm%20color%20grading&width=1200&height=700&seq=story-scene-03&orientation=landscape',
    date: '2025-03-16',
    dateLabel: '第 3 集 · 2025.03.16 播出',
    weight: 84,
    tags: ['饭桌', '关系', '陈默', '江暖', '陆嘉行'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 3 集' },
      { label: '场景', value: '江暖家 · 餐厅' },
      { label: '关键词', value: '体面 / 试探 / 三人' },
    ],
    quote: '最难演的不是吵架，是所有人都假装没事。',
    body: [
      '江暖做了一桌菜，说是庆祝陈默的新戏开机。陆嘉行带了一瓶酒，进门时很自然地换了鞋，把外套挂在第二个挂钩上——那个位置，陈默记得以前是自己的。',
      '整场戏几乎全靠细节撑起来。谁坐在哪一侧，谁先动筷，谁在听到"当年"两个字时停顿了半秒。江暖给两个人各夹了一筷子菜，顺序是先陆嘉行，再陈默。她做得很自然，陈默却低头笑了一下。',
      '中途陆嘉行接了个电话，走到阳台上。陈默看着他的背影，忽然说：他好像什么都不知道。江暖没有抬头，只是说：那就让他继续不知道。',
      '镜头最后停在桌上那副多出来的碗筷上。它从头到尾没有被动过。',
    ],
  },
  {
    id: 'story-4',
    type: 'story',
    title: '第四幕 · 婚宴上的空座',
    subtitle: '第 4 集｜一场不属于他们的婚礼',
    excerpt:
      '一场旧友的婚礼，把散落多年的人重新叫回了同一间宴会厅。主桌上留了一个空位，谁也没坐。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20chair%20at%20a%20lavish%20wedding%20banquet%20table%2C%20golden%20warm%20string%20lights%20and%20blurred%20guests%20in%20the%20background%2C%20white%20linen%20and%20glassware%2C%20deep%20shadowed%20edges%2C%20melancholic%20celebration%20mood%2C%20amber%20highlights%2C%20film%20grain%20texture%2C%20wide%20cinematic%20framing&width=1200&height=700&seq=story-scene-04&orientation=landscape',
    date: '2025-03-23',
    dateLabel: '第 4 集 · 2025.03.23 播出',
    weight: 80,
    tags: ['婚礼', '旧友', '空座', '秘密'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 4 集' },
      { label: '场景', value: '江畔酒店 · 宴会厅' },
      { label: '关键词', value: '体面 / 缺席 / 旧账' },
    ],
    quote: '有些人没来，座位上却全是他的影子。',
    body: [
      '婚礼是大学同学办的。请柬发到群里时，没人想到这三个人会同时出现。陈默到得最早，坐在角落；江暖和陆嘉行一起进来，被安排在主桌。',
      '主桌上有一个空位，摆着餐具，却始终没有人坐下。服务员想撤走，被新娘拦住了。她说，留着的。',
      '酒过三巡，有人起哄让陈默讲两句。他站起来，举着杯子，说了一句：祝你们都比我有勇气。全场笑了，只有江暖没有笑。',
      '散场时下起了小雨。陆嘉行去取车，江暖站在酒店廊下，陈默从她身边走过，两个人谁都没有停。镜头拉远，两个人中间隔着的那段距离，刚好是一个人能站下的宽度。',
    ],
  },
  {
    id: 'story-5',
    type: 'story',
    title: '第五幕 · 深夜来电',
    subtitle: '第 5 集｜凌晨三点十七分',
    excerpt:
      '凌晨三点十七分，陈默的手机响了。屏幕上没有名字，只有一串他删过很多次、却一直记得的号码。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20a%20glowing%20smartphone%20on%20a%20dark%20bedside%20table%20at%20night%20with%20an%20unknown%20incoming%20call%2C%20faint%20amber%20screen%20light%20illuminating%20a%20hand%2C%20deep%20charcoal%20bedroom%20shadows%2C%20rain%20streaks%20on%20window%20glass%20behind%2C%20restless%20nocturnal%20mood%2C%20shallow%20depth%20of%20field%2C%20film%20grain&width=1200&height=700&seq=story-scene-05&orientation=landscape',
    date: '2025-03-30',
    dateLabel: '第 5 集 · 2025.03.30 播出',
    weight: 92,
    tags: ['深夜', '电话', '陈默', '江暖'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 5 集' },
      { label: '场景', value: '陈默家 · 卧室' },
      { label: '关键词', value: '崩溃 / 求助 / 越界' },
    ],
    quote: '她只说了三个字：我害怕。',
    body: [
      '电话响了很久，陈默才接。那边先是沉默，然后是江暖的声音，很轻，像是怕吵醒谁。她说，我害怕。',
      '陈默问她在哪。她说在家里。陈默说，那我过来。她说，不用，你听我说完就好。',
      '接下来的十一分钟，是全剧最长的一次独白。江暖讲了很多年没讲过的事：她当年为什么走，为什么回来，为什么嫁给陆嘉行。她讲得很平静，平静到陈默几次以为她在说别人的故事。',
      '天亮前，电话挂了。陈默坐在床边，一直坐到窗帘透光。他没有去她家，也没有再打回去。这一集结束在他打开手机通讯录、把那个号码重新存成名字的瞬间。',
    ],
  },
  {
    id: 'story-6',
    type: 'story',
    title: '第六幕 · 归来的信',
    subtitle: '第 6 集｜一封没寄出的信，被寄出了',
    excerpt:
      '剧组整理旧道具时，从一本旧书里抖出一封信。信封上写着陈默的名字，邮戳却是七年前的。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20aged%20handwritten%20letter%20slipping%20out%20of%20an%20old%20hardcover%20book%20on%20a%20props%20table%2C%20warm%20amber%20work%20light%2C%20dust%20motes%2C%20deep%20brown%20backstage%20shadows%2C%20paper%20texture%20detail%2C%20nostalgic%20quiet%20tone%2C%20shallow%20depth%20of%20field%2C%20subtle%20film%20grain&width=1200&height=700&seq=story-scene-06&orientation=landscape',
    date: '2025-04-06',
    dateLabel: '第 6 集 · 2025.04.06 播出',
    weight: 86,
    tags: ['信', '过去', '真相', '陈默'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 6 集' },
      { label: '场景', value: '旧片场 · 道具间' },
      { label: '关键词', value: '误会 / 迟到的真相' },
    ],
    quote: '有些解释，寄出去的时候就已经过期了。',
    body: [
      '道具师抱来一箱旧书，说都是从老片场淘的。陈默随手翻了一本，一封信从书页里滑出来，落在地上。',
      '信封上写着他的名字，字迹他认得。邮戳是七年前的秋天，可他从来没有收到过。信没有封口，里面只有一张纸，短短五行字：我要走了，别找我。如果你愿意等，我会回来。',
      '陈默拿着信站了很久，然后问道具师，这箱书是从哪儿来的。道具师说，是陆先生上周送来的，说是家里清出来的旧物。',
      '这一集没有给出解释，只给了一个问题：这封信，是被人扣下的，还是被人遗忘了。镜头切到陆嘉行在阳台上打电话，他说，那箱东西，你都处理掉了吧。',
    ],
  },
  {
    id: 'story-7',
    type: 'story',
    title: '第七幕 · 楼梯间的对话',
    subtitle: '第 7 集｜两层楼之间，两个人都没有上楼',
    excerpt:
      '陆嘉行在楼梯间拦住陈默。没有争吵，只有一句：你是不是早就知道。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20men%20facing%20each%20other%20in%20a%20dim%20concrete%20stairwell%2C%20one%20leaning%20against%20the%20railing%2C%20single%20warm%20wall%20sconce%20above%2C%20long%20hard%20shadows%20across%20the%20steps%2C%20restrained%20confrontation%20mood%2C%20deep%20charcoal%20tones%20with%20amber%20accent%2C%20film%20grain%2C%20tense%20cinematic%20composition&width=1200&height=700&seq=story-scene-07&orientation=landscape',
    date: '2025-04-13',
    dateLabel: '第 7 集 · 2025.04.13 播出',
    weight: 90,
    tags: ['对峙', '陆嘉行', '陈默', '兄弟'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 7 集' },
      { label: '场景', value: '公寓楼 · 楼梯间' },
      { label: '关键词', value: '摊牌 / 朋友 / 界限' },
    ],
    quote: '我们是朋友，所以你才更不能说。',
    body: [
      '陆嘉行在楼梯间等了他很久，烟抽了两支。陈默上来的时候，他正好把第二支按灭在墙角。',
      '他说，那封信，你看到了吧。陈默说，看到了。陆嘉行问，你是不是早就知道她回来过。陈默沉默了几秒，说，我也是那天才知道。',
      '两个人站在两层楼之间，谁都没有往上走。陆嘉行忽然笑了一下，说，你知道吗，这七年我最怕的不是你们见面，是你们见面以后，还跟没事人一样。',
      '这一集最后，陈默说了一句话：嘉行，我从来没有想过要抢你的东西。陆嘉行看着他，说，可她不是东西。楼道灯灭了，两个人在黑暗里站着，谁也没有去按开关。',
    ],
  },
  {
    id: 'story-8',
    type: 'story',
    title: '第八幕 · 海边的坦白',
    subtitle: '第 8 集｜潮水退了，话才说出口',
    excerpt:
      '江暖约陈默去海边。她说，有些话在城里说不出口，得找个没有墙的地方。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20two%20figures%20walking%20apart%20along%20a%20grey%20overcast%20beach%20at%20dusk%2C%20wet%20sand%20reflecting%20pale%20golden%20light%2C%20low%20waves%2C%20wind%20blown%20coats%2C%20vast%20empty%20horizon%2C%20melancholic%20restrained%20mood%2C%20muted%20warm%20grey%20palette%2C%20film%20grain%2C%20wide%20cinematic%20shot&width=1200&height=700&seq=story-scene-08&orientation=landscape',
    date: '2025-04-20',
    dateLabel: '第 8 集 · 2025.04.20 播出',
    weight: 94,
    tags: ['海边', '坦白', '江暖', '陈默'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 8 集' },
      { label: '场景', value: '南岸 · 防波堤' },
      { label: '关键词', value: '告白 / 抉择 / 告别' },
    ],
    quote: '我不是来带你走的，我是来告诉你，我不走了。',
    body: [
      '海边风很大。江暖把头发别到耳后，说，我一直以为，只要我不说，这件事就会自己过去。后来发现，它只是沉下去了。',
      '她讲了那个秋天。她父亲病重，家里欠了钱，陆嘉行替她扛下了一切。她嫁给他的时候，心里想的是报恩，不是爱情。她说，我知道这很难听，但这是真的。',
      '陈默问她，那你现在呢。江暖看着海，说，现在我想为自己活一次，但我不想踩着任何人。',
      '这一集最重要的不是告白，是拒绝。陈默说，我不会带你走。他说，我等过你七年，不是为了让你在愧疚里跟我走。潮水退下去，两个人在沙滩上留下两行平行的脚印，没有交汇。',
    ],
  },
  {
    id: 'story-9',
    type: 'story',
    title: '终章 · 灯亮之后',
    subtitle: '第 12 集｜戏拍完了，人也该散了',
    excerpt:
      '杀青那天，陈默把最后一场戏留在了"归途"酒吧。灯亮起来的时候，柜台后面已经没有人了。',
    image:
      'https://readdy.ai/api/search-image?query=Cinematic%20film%20still%20of%20an%20empty%20small%20bar%20interior%20with%20lights%20just%20turned%20on%2C%20rows%20of%20bottles%20glinting%20amber%2C%20wooden%20counter%20and%20a%20single%20folded%20towel%2C%20morning%20light%20through%20the%20door%2C%20dust%20in%20the%20air%2C%20quiet%20aftermath%20mood%2C%20warm%20honey%20tones%20against%20deep%20shadow%2C%20film%20grain%2C%20elegant%20composition&width=1200&height=700&seq=story-scene-09&orientation=landscape',
    date: '2025-04-27',
    dateLabel: '第 12 集 · 2025.04.27 播出',
    weight: 98,
    tags: ['终章', '杀青', '告别', '陈默', '江暖'],
    meta: [
      { label: '所属剧集', value: '《我的朋友他的妻子》第 12 集' },
      { label: '场景', value: '旧城 · 归途酒吧' },
      { label: '关键词', value: '和解 / 放下 / 新生' },
    ],
    quote: '灯亮之后，故事才真正开始属于观众。',
    body: [
      '最后一场戏拍了十七条。导演说要的不是哭，是那种"已经把眼泪咽回去"的表情。陈默坐在吧台前，手里握着一杯没有酒的空杯子，重复了十七次同一句台词。',
      '江暖没有出现在片场。她留了一封信在道具箱里，只有一句话：这次换我先走，你别找。',
      '杀青宴上，陆嘉行来了。他坐在角落，喝了一杯就走。临走前他拍了拍陈默的肩，说，戏不错。陈默说，谢谢。两个人第一次没有剑拔弩张，也没有和解的拥抱，只是各自走开。',
      '结尾是一个长镜头。清晨的酒吧，灯刚刚亮起来，柜台后面空着，毛巾叠得整整齐齐。画外音是陈默的声音：这个故事里没有坏人，只有三个都太用力的人。',
    ],
  },
];